import React from 'react';
import "../navbar/navBar.css"

const Navbar = () => {
  return (
    <div className="navBar"></div>
  );
}

export default Navbar;
